import React from 'react';
import { ErrorLayout, MainLayout } from '@layouts';
import { withUser } from '@modules/auth';
import { getGalleryProjects } from '@modules/get-data';
import { GalleryPage } from '@sections/Gallery-Page';
import { GALLERY_PATH, PROCESSING_ITEMS } from '@constants';
import { findDescriptionTag } from '../../../sections/Gallery-Page/helpers';
import { getErrorContent, redirect } from '@libs';
import { ErrorStub } from '@components/Error-Stub';

const GalleryProjects = ({ tags, projects, queryTags }) => (
    <GalleryPage projects={projects}
                 tags={tags}
                 queryTags={queryTags} />
);

GalleryProjects.getLayout = (page, { queryTags, tags, currentTag, errorCode }) => {
  const { translations } = page.props;
  const description = (currentTag && currentTag.description) ? currentTag.description.replace(/<\/?[^>]+(>|$)/g, "").split('. ').slice(0, 2).join('. ') : '';

  if (errorCode || !currentTag) {
    const error = getErrorContent({ code: errorCode });

    return (
        <ErrorLayout title={translations.t('site.galleryProjects.title')}>
          <ErrorStub error={error} />
        </ErrorLayout>
    );
  }

  return (
      <MainLayout
          title={`${currentTag ? `${currentTag.title || currentTag.name} -` : ''} ${translations.t('site.galleryProjects.title')}`}
          processing={PROCESSING_ITEMS.GET_BLOG}
          description={description}
          keywords={currentTag ? currentTag.name : ''}>
        {page}
      </MainLayout>
  )
};

GalleryProjects.getInitialProps = async ({ store, query, res }) => {
  const { dispatch, getState } = store;
  const data = await dispatch(getGalleryProjects(query));
  const currentTag = findDescriptionTag({ queryTags: data.queryTags, tags: data.tags });
  const { errors, settings: { locale }} = getState();

  const error = errors[PROCESSING_ITEMS.GET_GALLERY_PROJECTS];

  if (error) {
    if (res && (error.code === 404 || error.code === 500)) {
      res.statusCode = error.code;
    }

    return { ...data, currentTag, errorCode: error.code };
  }

  if (!currentTag) {
    redirect(`/${locale}/${GALLERY_PATH}/`, { locale }, 301, res);
  }

  return {...data, currentTag};
};

export default withUser(GalleryProjects);
